import { BASE_URL, COMPANY_DEPARTMENT } from "constants/api";
import axios from "../helpers/axiosInstance";
import { HeadCell } from "models/app";
import {
  ICompanyDepartments,
  ICompanyDepartmentsInput,
  ICompanyDepartmentsInputEdit,
} from "models/companyDepartment";

export async function getCompanyDepartments(params: string = ""):Promise<ICompanyDepartments[]> {
  const response = await axios.get(BASE_URL + COMPANY_DEPARTMENT + params);
  return response.data;
}
export async function addCompanyDepartment(data: ICompanyDepartmentsInput) {
  const response = await axios.post(BASE_URL + COMPANY_DEPARTMENT, data);
  return response.data;
}

export async function editCompanyDepartment(
  data: ICompanyDepartmentsInputEdit,
  id: string
) {
  const response = await axios.patch(
    BASE_URL + COMPANY_DEPARTMENT + "/" + id,
    data
  );
  return response.data;
}

export async function deleteCompanyDepartment(id: string) {
  const response = await axios.delete(BASE_URL + COMPANY_DEPARTMENT + "/" + id);
  return response.data;
}

export const CompanyDepartmentsCells: HeadCell[] = [
  {
    id: "name",
    numeric: false,
    disablePadding: false,
    label: "T_name",
  },
  {
    id: "nameAr",
    numeric: false,
    disablePadding: false,
    label: "T_name_Ar",
  },
 
  {
    id: "headOfDepartmentName",
    numeric: false,
    disablePadding: false,
    label: "T_hod",
  },
  {
    id: "headOfDepartmentNameAr",
    numeric: false,
    disablePadding: false,
    label: "T_hod_ar",
  },
  {
    id: "approvingOfficerName",
    numeric: false,
    disablePadding: false,
    label: "T_approving_officer",
  },
  {
    id: "approvingOfficerNameAr",
    numeric: false,
    disablePadding: false,
    label: "T_approving_officer_ar",
  },
  {
    id: "actions",
    numeric: false,
    disablePadding: false,
    label: "T_action",
  },
];
